import { createContext, useContext } from 'react';

interface SocketContextType {
  isConnected: boolean;
  unreadCount: number;
  setUnreadCount: (n: number | ((prev: number) => number)) => void;
}

export const socketContext = createContext<SocketContextType>({
  isConnected: false,
  unreadCount: 0,
  setUnreadCount: () => {},
});

export const useSocketContext = () => useContext(socketContext);
